export default __webpack_public_path__ + "8e175e3d32b5c0a38dfb9146a4c39ded.svg";